
import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import TextUI from '@/components/UI/Text.vue'

@Component({
  components: {
    TextUI
  }
})
export default class CopyrightVue extends Vue {
  rating = Number(localStorage.getItem('oneword-app-rating') || 0)

  get versionLabel() {
    const version = process.env.VUE_APP_VERSION || 'dev'
    const buildNumber = process.env.VUE_APP_BUILD_NUMBER || 'local'

    return `v${version} (${buildNumber})`
  }

  get isAppleMobileBrowser() {
    const navigator = window.navigator
    return /iPhone|iPad|iPod/.test(navigator.userAgent)
      || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  }

  ratingLabel(value: number) {
    return this.$i18n.locale === 'ru'
      ? `Оценка ${value} из 5`
      : `Rating ${value} out of 5`
  }

  submitRating(value: number) {
    this.rating = Math.max(1, Math.min(5, value))
    localStorage.setItem('oneword-app-rating', String(this.rating))

    if ((process.env.VUE_APP_NATIVE === 'true' || this.isAppleMobileBrowser) && this.rating >= 4) {
      window.location.href = 'https://apps.apple.com/app/id6798096283?action=write-review'
      return
    }

    const stars = '★'.repeat(this.rating)
    const subject = 'The Only Word Online — feedback'
    const body = `My Score: ${stars}; My Review: (Please write your review here)`
    window.location.href = `mailto:info@economicusgame.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
  }
}
